import { Controller } from "@hotwired/stimulus";
const pdfjs = require("pdfjs-dist/build/pdf.js");
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default class extends Controller {
  static targets = ["canvas", "pdfElement"];
  static values = {
    zoom: { type: Number, default: 100 },
    url: String
  };

  connect() {
    this.load();
  }

  // Method to recalculate size when container changes
  recalculateSize() {
    // Clear existing content and reload if URL is available
    if (this.hasUrlValue && this.urlValue) {
      this.clearContent();
      this.load();
    }
  }

  clearContent() {
    if (this.hasPdfElementTarget) {
      this.pdfElementTarget.innerHTML = '';
    }
  }

  load() {
    const pdfUrl = this.urlValue || this.data.get("url");

    if (pdfUrl === "") {
      return;
    }

    pdfjs
      .getDocument(pdfUrl)
      .promise.then((pdf) => {
        const pdfElement = this.pdfElementTarget;
        let pageNum = 0;
        while (pageNum < pdf.numPages) {
          pageNum++;
          pdf.getPage(pageNum).then((page) => {
            const scale =
              (this.element.offsetWidth * window.devicePixelRatio) /
              page.getViewport({ scale: 1.0 }).width;

            // we will default to a scale of 2 for any element that is
            // hidden on initial rendering into the DOM e.g., the new apps review workflow
            const viewport = page.getViewport({ scale: scale * 2 || 2 });

            const content = `<div class="page pdf-page-wrapper-${page.pageIndex}"><canvas class="pdf-page pdf-page-${page.pageIndex}"></canvas></div>`;
            pdfElement.insertAdjacentHTML("beforeend", content);
            const canvas = this.element.querySelector(
              `.pdf-page-${page.pageIndex}`
            );
            const wrapper = this.element.querySelector(
              `.pdf-page-wrapper-${page.pageIndex}`
            );
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvas.style.width = "100%";
            canvas.style.height = "auto";
            wrapper.style.width = "100%";
            wrapper.style.height = "auto";
            page.render({
              canvasContext: canvas.getContext("2d"),
              viewport: viewport
            });
          });
        }

        // Notify height manager that PDF has loaded
        this.notifyHeightManager();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  zoomIn(e) {
    e.preventDefault();
    let newZoomValue = this.zoomValue + 25;

    if (newZoomValue <= 200) {
      this.canvasTarget.style.width = `${newZoomValue}%`;
      this.zoomValue = newZoomValue;
    }
  }

  zoomOut(e) {
    e.preventDefault();
    let newZoomValue = this.zoomValue - 25;

    if (newZoomValue >= 100) {
      this.canvasTarget.style.width = `${newZoomValue}%`;
      this.zoomValue = newZoomValue;
    }
  }

  urlValueChanged() {
    if (this.urlValue !== "") {
      this.load();
    }
  }
  notifyHeightManager() {
    // Find the profile height manager controller and notify it that PDF has loaded
    const rightPanel = this.element.closest('[data-controller*="profile-height-manager"]');
    if (rightPanel) {
      const heightManager = this.application.getControllerForElementAndIdentifier(
        rightPanel,
        'profile-height-manager'
      );

      if (heightManager && typeof heightManager.recalculateHeights === 'function') {
        // Small delay to allow PDF rendering to complete
        setTimeout(() => {
          heightManager.recalculateHeights();
        }, 100);
      }
    }
  }
}
